export default __webpack_public_path__ + "static/media/5.db73373d.jpg";